"use client";

import { createContext, useContext } from "react";
import type { MultitenantConfig } from "@/lib/tenant-config/getMultitenantConfig";

const MultitenantConfigContext = createContext<MultitenantConfig | null>(null);

export function MultitenantConfigProvider({
  config,
  children,
}: {
  config: MultitenantConfig | null;
  children: React.ReactNode;
}) {
  return (
    <MultitenantConfigContext.Provider value={config}>
      {children}
    </MultitenantConfigContext.Provider>
  );
}

export function useMultitenantConfig(): MultitenantConfig | null {
  return useContext(MultitenantConfigContext);
}
